"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSelectorCard = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var sanitize_1 = require("../../utils/sanitize");
var Icon_1 = require("../Icon");
var Pictogram_1 = require("../Pictogram");
var ProductSelectorCard = function (props) {
    var inputAttributes = {
        className: 'sr-only',
        id: props.id,
        name: props.name,
        type: props.type,
        value: props.value,
    };
    // Add the onChange handler
    if (typeof props.onChange === 'function') {
        inputAttributes.onChange = function (e) {
            var name = props.value;
            var value = e.target.checked;
            // @ts-ignore
            props.onChange(name, value, e);
        };
        inputAttributes.checked = props.checked;
    }
    else {
        inputAttributes.defaultChecked = props.checked;
    }
    var children = props.children;
    if (typeof children === 'string') {
        if (children.substring(0, 1) !== '<') {
            // Wrap in a paragraph if it's not inside some type of HTML
            children = "<p>" + children + "</p>";
        }
        // Sanitize HTML
        children = (React.createElement("div", { dangerouslySetInnerHTML: (0, sanitize_1.sanitize)(children) }));
    }
    if (props.screenReaderText) {
        inputAttributes['aria-label'] = props.screenReaderText;
    }
    else {
        inputAttributes['aria-labelledby'] = props.id + "-choose " + props.id + "-title";
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "productcard pt-4 pb-4 " + (inputAttributes.checked ? 'selected' : '') },
            props.isRecommendedPrimary && (React.createElement("span", { className: "productcard--recommended-primary" },
                " ",
                props.isRecommendedPrimaryText,
                " ")),
            props.isRecommendedSecondary && (React.createElement("span", { className: "productcard--recommended-secondary" },
                " ",
                props.isRecommendedSecondaryText,
                " ")),
            React.createElement("div", { className: "productcard__elem pl-3 pr-3" },
                props.pictogram && (React.createElement(Pictogram_1.Pictogram, { name: props.pictogram, alt: "" })),
                props.imageSrc && (React.createElement("img", { src: props.imageSrc, alt: "", className: "productcard__img" })),
                props.title &&
                    React.createElement("h2", { id: props.id + "-title" }, props.title),
                props.description &&
                    React.createElement("p", { className: "productcard__description mb-3" }, props.description),
                React.createElement("div", { className: "productcard__content" },
                    children,
                    props.hyperLink && (React.createElement(Icon_1.Icon, __assign({}, (props.hyperLinkTarget && { target: props.hyperLinkTarget }), { isInline: true, isRHS: true, symbol: "controlLinkOut24", href: props.hyperLink, screenreader: props.title }), props.hyperLinkText)))),
            React.createElement("div", { className: "productcard__label" },
                React.createElement("input", __assign({}, inputAttributes)),
                React.createElement("label", { htmlFor: props.id, id: props.id + "-choose" },
                    React.createElement("span", { className: "productcard__cta" },
                        " ",
                        props.selectText))))));
};
exports.ProductSelectorCard = ProductSelectorCard;
exports.ProductSelectorCard.defaultProps = {
    checked: false,
    type: 'radio',
};
exports.ProductSelectorCard.propTypes = {
    checked: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    description: PropTypes.string,
    hyperLink: PropTypes.string,
    hyperLinkTarget: PropTypes.oneOf(['_self', '_blank', '_parent', '_top']),
    hyperLinkText: PropTypes.string,
    id: PropTypes.string.isRequired,
    imageSrc: PropTypes.string,
    isRecommendedPrimary: PropTypes.bool,
    isRecommendedPrimaryText: PropTypes.string,
    isRecommendedSecondary: PropTypes.bool,
    isRecommendedSecondaryText: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    pictogram: PropTypes.string,
    screenReaderText: PropTypes.string,
    selectText: PropTypes.string,
    title: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
    value: PropTypes.string.isRequired,
};
